<template>
  <div style="display: inline-block;">
    <AddProducts :product="product" :copyform="copyform" v-on:add="submit" :isSingle="true">
      <slot></slot>
    </AddProducts>
  </div>
</template>

<script>
import AddProducts from '../components/AddProducts'

export default {
  name: 'TaskAdd',
  props: ['product','copyform'],
  components: {
    AddProducts: AddProducts
  },
  computed: {
  },
  computed: {
    taskInfo () {

	    return this.$store.state.taskInfo
    }
  },
  data () {
    return {
    }
  },
  methods: {
    submit (form) {
      if (!form.price) {
        form.price = form.discounted_price
      }
      if (!form.discounted_price) {
        form.discounted_price = form.price
      }
      if(!form.good_id) {
        form.good_id = '0'
      }
      if(form.color || form.size) {
        form.onekey = 1
      }
      if (form.id) {
        _.each(this.taskInfo.goods_list, goods => {
          if (form.id === goods.id) {
            Object.assign(goods, form)
          }
        })
      } else {
        form.id = +new Date()
        this.taskInfo.business_id = form.business_id
        this.taskInfo.business_name = form.business_name
        this.taskInfo.business_website = form.business_website
        this.taskInfo.goods_list = this.taskInfo.goods_list || []
        if(this.copyform){
          if(this.copyform.business_name == form.business_name && this.copyform.business_website == form.business_website && this.copyform.name == form.name && this.copyform.spec == form.spec && this.copyform.price == form.price && this.copyform.discounted_price == form.discounted_price && this.copyform.picture == form.picture && this.copyform.website == form.website && this.copyform.currency == form.currency) {
            _.each(this.taskInfo.goods_list,item => {
              if(item.id == this.copyform.id){
                item.number = Number(item.number) + 1
                return false
              }
            })

          }else{
            this.taskInfo.goods_list.push(form)
          }
        }else{
          this.taskInfo.goods_list.push(form)
        }
        
        this.taskInfo.goods_list = _.orderBy(this.taskInfo.goods_list, ['id'], ['desc']);
      }
      this.taskInfo.business = form.business
      this.$store.commit('updateTaskInfo', this.taskInfo)
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/publish_task/product/AddProducts.vue